<template>
    <input type="text"
           class="tc-name-input"
           :value="value"
           @change="$emit('change', $event.target.value)">
</template>

<script>
export default {
    name: 'nameInput',
    props: [
        'value',
    ],
    emits: [
        'change',
    ],
};
</script>

<style scoped lang="scss">
.tc-name-input {
    height: 40px;
    width: 100%;
    padding: 0 40px 0 13px;
    box-sizing: border-box;
    border: 1px solid #D9D9D9;
    color: #333333;
    font-size: 16px;
    outline: none;
}
</style>
